import type { AiCompanyArticle } from '../../types/news'

/**
 * Published, source-linked OMIKINA editorials are durable timeline records.
 * 30-minute discovery signals are intentionally excluded because they expire with
 * the current edition and have not been promoted to reviewed archive entries.
 */
export function buildEditorialTimeline(articles: AiCompanyArticle[], companySlugs: string[]): AiCompanyArticle[] {
  const included = new Set(companySlugs)
  return articles
    .filter((article) => article.articleKind !== 'platform-update' && included.has(article.companySlug))
    .sort((a, b) => new Date(b.generatedAt).getTime() - new Date(a.generatedAt).getTime() || a.headline.localeCompare(b.headline))
}
